import ErrorImage from "../components/ErrorImage.js";

export default function UserManagementPage() {
  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <div className="flex-1 flex flex-col">
        <div className="flex-1 p-4 sm:p-8">
          <div className="bg-white shadow rounded-lg p-4 md:max-w-[calc(100vw-375px)] sm:p-6 text-sm md:mt-0">
            <ErrorImage />
          </div>
        </div>
      </div>
    </div>
  );
}
